import { type Enum } from "@/types";
/**
 * While it will be easy to simply disable the magic numbes rule all together, that will
 * disrourage the developer from creating meaningful variables initially, and puts the onus
 * on the reviewer to catch somithing the linter can do for them. We can allow disabling the
 * rules line by line until that becomes a burden, as it is more obvious to the author and
 * the reviewer that the line is supposed to be an exception and not the starting point.
 */

/**
 * So evidently there might not be a word for this. Intended to be used to convert between the
 * significant metric prefixes, like nano, micro, milli, kilo, etc.
 */
const MetricConversionDelta = 1000;
const SecondsPerMinute = 60;
const MinutesPerHour = 60;
const HoursPerDay = 24;
const DaysPerWeek = 7;
const DaysPerMonth = 30;
const DaysPerYear = 365;

export const SECOND = MetricConversionDelta;
export const MINUTE = SecondsPerMinute * SECOND;
export const HOUR = MinutesPerHour * MINUTE;
export const DAY = HoursPerDay * HOUR;
export const WEEK = DaysPerWeek * DAY;
export const MONTH = DaysPerMonth * DAY;
export const YEAR = DaysPerYear * DAY;

/**
 * Various times in milliseconds.
 */
export const time = {
  HALF_SECOND: 500,
  ONE_SECOND: SECOND,
  TWO_SECONDS: SECOND * 2,
  THREE_SECONDS: SECOND * 3, // eslint-disable-line @typescript-eslint/no-magic-numbers
  THIRTY_SECONDS: SECOND * 30, // eslint-disable-line @typescript-eslint/no-magic-numbers
} as const;

export type Time = Enum<typeof time>;
